<ng-container *ngIf='variableMap'>
  <shared-ui-information-element [information]='getInformationElementStudentFullname()'></shared-ui-information-element>
  <shared-ui-information-element [information]='getVorstudium()'></shared-ui-information-element>
  <shared-ui-information-element
    [information]='getInformationElementProcessStarted()'
    type='date'
    format='dd.MM.yyyy HH:mm'
  ></shared-ui-information-element>
</ng-container>
